module.exports = __webpack_public_path__ + "static/media/develop_bg.c784eeee.png";